import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { useSyncExternalStore } from "use-sync-external-store/shim";
import { isWindowUndefined } from "./isWindowUndefined";
var _isHydrating = getGlobalProperty("needsHydration", false);
/**
 * Return true during server-side rendering or client hydration.
 *
 * This returns true during client hydration because React requires that the result
 * of server-side rendering matches the initial render ("hydration") on the client.
 *
 * More information: https://www.joshwcomeau.com/react/the-perils-of-rehydration
 */ export var maybeSSR = function() {
    return isWindowUndefined() || _isHydrating;
};
export var handleWillHydrate = function() {
    _isHydrating = true;
};
var _hydarationCallbacks = [];
export var handleHydrationCompleted = function() {
    _isHydrating = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = _hydarationCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cb = _step.value;
            cb();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    _hydarationCallbacks = [];
};
/**
 * @deprecated replace with useIsSSR.
 */ export var onHydration = function(cb) {
    if (_isHydrating) {
        _hydarationCallbacks.push(cb);
    }
};
/**
 * Hook that returns true during SSR and hydration.
 */ export var useIsSSR = function() {
    return useSyncExternalStore(// The value never changes, no need to subscribe.
    function() {
        return function() {};
    }, // Called during client rendering
    maybeSSR, // During hydration, we need to match SSR.
    function() {
        return true;
    });
};
